import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { BehaviorSubject, combineLatest, interval, merge, NEVER, of, Subject } from 'rxjs';
import { buffer, concatMap, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { PageActivity } from './domUtil';
import uniqWith from 'lodash/uniqWith';
import isEqual from 'lodash/isEqual';

/**
 * Background Dataloader that uses PageActivity and Stale Observables to buffer fetching items.
 */
export var BackgroundDataLoader = /*#__PURE__*/function () {
  function BackgroundDataLoader(pageActivity$, stale$) {
    _classCallCheck(this, BackgroundDataLoader);
    this.subject = new Subject();
    this.loadingSubject = new BehaviorSubject(false);
    this.loading$ = this.loadingSubject.asObservable();
    // when the user is activly on the page release the buffer every second
    // otherwise just keep buffering until the user comes back to the page
    this.release$ = combineLatest(merge(of(PageActivity.Active), pageActivity$), stale$, this.loading$).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
        pageActivity = _ref2[0],
        stale = _ref2[1],
        loading = _ref2[2];
      return pageActivity === PageActivity.Active && !stale && !loading;
    }), distinctUntilChanged(), switchMap(function (active) {
      return active ? interval(1000) : NEVER;
    }));
  }

  /**
   * Start listening to request to fetch items.
   *
   * @param {*} fetchItems
   * @returns
   */
  return _createClass(BackgroundDataLoader, [{
    key: "start",
    value: function start(fetchItems) {
      var _this = this;
      if (!this.sub) {
        this.sub = this.subject.pipe(buffer(this.release$), filter(function (x) {
          return x.length !== 0;
        }), concatMap(/*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(x) {
            var uniqueArray, result;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _this.loadingSubject.next(true);
                  uniqueArray = uniqWith(x, isEqual);
                  _context.next = 4;
                  return fetchItems(uniqueArray);
                case 4:
                  result = _context.sent;
                  _this.loadingSubject.next(false);
                  return _context.abrupt("return", result);
                case 7:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }())).subscribe();
      }
      // Returns a disposer function to stop.
      return function () {
        return _this.sub.unsubscribe();
      };
    }
  }, {
    key: "load",
    value: function load(data) {
      this.subject.next(data);
    }
  }]);
}();
//# sourceMappingURL=bufferUtil.js.map
